import { SyncOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const Container = styled.div`
display: flex;
gap: 12px;

@media screen and (max-width: 400px) {
   gap: 8px;
}
`;

export const ActionButton = styled.div`
display: flex;
gap: 8px;
justify-content: flex-end;
align-items: center;
padding: 8px;
border-radius: 8px;
background-color: #212224;
cursor: pointer;

:first-child {
    flex: 1;
}

@media screen and (max-width: 400px) {
   gap: 4px;
}

@media screen and (max-width: 390px) {
    svg {
        width: 20px;
    }
}

@media screen and (max-width: 330px) {
padding: 3px 6px;
}
`;

export const Text = styled.div`
padding-left: 4px;
font-size: 12px;
font-style: normal;
font-weight: 600;
line-height: 1.5;
color: #F9F9F9;

@media screen and (max-width: 390px) {
    font-size: 10px;
}

@media screen and (max-width: 340px) {
padding-left: 0;
}

@media screen and (max-width: 340px) {
font-size: 9px;
}
`;

export const BalanceText = styled(Text)`
flex: 1;
text-align: left;
padding: 0;
position: relative;
`;

export const RefreshIcon = styled(SyncOutlined)`
font-size: 18px;
color: ${props => props.theme.primaryColor};
`;